module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Payments history","refunded":"Refunded","currency":{"RUB":"RUB"}}}')
  delete Component.options._Ctor
}
